import {createContext} from "react";

export default createContext(process.env.REACT_APP_LANGUAGE);
